// utils/k3flow.js

// Convert flow (object) thành K3Doc
export function flowToK3Doc(flow) {
  return {
    _id: flow._id,
    doc_mid: flow.flow_mid,
    friendly_version: flow.friendly_version,
    type: 'flow',
    title: flow.title,
    content: flow.description || flow.title,
    metadata: {
      ...flow.metadata,
      nodes: flow.nodes,
      edges: flow.edges
    }
  };
}

// Convert K3Doc thành flow (object)
export function k3DocToFlow(doc) {
  return {
    _id: doc._id,
    flow_mid: doc.doc_mid,
    friendly_version: doc.friendly_version,
    title: doc.title,
    description: doc.content,
    nodes: doc.metadata?.nodes || [],
    edges: doc.metadata?.edges || [],
    metadata: doc.metadata || {}
  };
} 